import GetMyRegistrationTypeRequestModelBase from '../_generated/modelBases/get-my-registration-type-request-model-base';

export default class GetMyRegistrationTypeRequestModel extends GetMyRegistrationTypeRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
